(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dissolvi-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dv-pdp').forEach(function(root){
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    if(!tiers.length) return;
    var qtyInput = root.querySelector('[data-qty-input]');
    var atcTotal = root.querySelector('[data-atc-total]');
    var fill = root.querySelector('[data-ship-fill]');
    var msg = root.querySelector('[data-ship-msg]');
    var threshold = parseInt(root.getAttribute('data-ship-threshold'), 10) || 0;
    var remainTpl = root.getAttribute('data-ship-remaining') || '';
    var unlockedTxt = root.getAttribute('data-ship-unlocked') || '';
    function money(c){ return '$' + (c/100).toFixed(2); }
    function pick(t){
      tiers.forEach(function(x){ x.classList.remove('is-sel'); x.setAttribute('aria-pressed','false'); });
      t.classList.add('is-sel'); t.setAttribute('aria-pressed','true');
      var qty = parseInt(t.getAttribute('data-qty'), 10) || 1;
      var net = parseInt(t.getAttribute('data-net'), 10) || 0;
      if(qtyInput) qtyInput.value = qty;
      if(atcTotal) atcTotal.textContent = ' - ' + money(net);
      var st = root.querySelector('[data-sticky-total]'); if(st) st.textContent = ' - ' + money(net);
      if(fill && threshold > 0){ fill.style.width = Math.min(100, Math.round(net / threshold * 100)) + '%'; }
      if(msg){
        if(net >= threshold){ msg.innerHTML = unlockedTxt; }
        else { msg.innerHTML = remainTpl.replace('{amount}', '<b>' + money(threshold - net) + '</b>'); }
      }
    }
    tiers.forEach(function(t){ t.addEventListener('click', function(){ pick(t); }); });
    var def = root.querySelector('[data-tier].is-sel') || tiers[0];
    pick(def);
    root.querySelectorAll('.dv-pdp__thumb').forEach(function(th){
      th.addEventListener('click', function(){
        var kind = th.getAttribute('data-art');
        var tpl = root.querySelector('[data-art-tpl="' + kind + '"]');
        var main = root.querySelector('[data-gallery-main]');
        if(tpl && main){ main.innerHTML = tpl.innerHTML; }
        root.querySelectorAll('.dv-pdp__thumb').forEach(function(x){ x.classList.remove('is-cur'); });
        th.classList.add('is-cur');
      });
    });
    var atcBtn = root.querySelector('.dv-pdp__atc');
    var stickyBar = root.querySelector('[data-stickybar]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    if(stickyAdd && atcBtn){ stickyAdd.addEventListener('click', function(){ atcBtn.click(); }); }
    if(stickyBar && atcBtn && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){ entries.forEach(function(e){ var show = !e.isIntersecting && e.boundingClientRect.top < 0; stickyBar.classList.toggle('is-shown', show); stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true'); }); }, { threshold: 0 }).observe(atcBtn);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-bundle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bundle-add]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var ids = [btn.getAttribute('data-v1'), btn.getAttribute('data-v2'), btn.getAttribute('data-v3')].filter(Boolean);
      var items = ids.map(function(id){ return { id: parseInt(id, 10), quantity: 1 }; });
      btn.disabled = true; var old = btn.textContent; btn.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){
          btn.disabled = false; btn.textContent = 'Added ✓';
          setTimeout(function(){ btn.textContent = old; }, 2400);
          document.dispatchEvent(new Event('dv:cart:added'));
        })
        .catch(function(){ btn.disabled = false; btn.textContent = old; var e = document.querySelector('[data-bundle-err]'); if(e) e.style.display = 'block'; });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.v2cart').forEach(function(root){
    function change(line, qty){
      fetch('/cart/change.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function(r){ return r.json(); })
        .then(function(){ window.location.reload(); })
        .catch(function(){ window.location.reload(); });
    }
    root.querySelectorAll('.v2row').forEach(function(row){
      var line = parseInt(row.getAttribute('data-line'), 10);
      var val = row.querySelector('[data-qval]');
      row.querySelector('[data-qplus]').addEventListener('click', function(){ change(line, parseInt(val.textContent,10) + 1); });
      row.querySelector('[data-qminus]').addEventListener('click', function(){ change(line, Math.max(0, parseInt(val.textContent,10) - 1)); });
      row.querySelector('[data-qremove]').addEventListener('click', function(){ change(line, 0); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var THRESHOLD = 7500;
  function money(c){ return '$' + (c/100).toFixed(2); }
  var drawer = document.querySelector('[data-dv-drawer]');
  var overlay = document.querySelector('[data-dv-overlay]');
  if(!drawer) return;
  function setShip(total){
    var chip = document.querySelector('[data-dv-chip]');
    var chipText = document.querySelector('[data-dv-chiptext]');
    var unlocked = total >= THRESHOLD;
    if(chip && chipText){
      if(unlocked){ if(!chip.classList.contains('is-unlocked')){ chip.classList.add('is-unlocked'); } chipText.textContent = 'Free shipping unlocked'; }
      else { chip.classList.remove('is-unlocked'); chipText.textContent = total > 0 ? (money(THRESHOLD - total) + ' to free shipping') : 'Free shipping over $75'; }
    }
    var ship = drawer.querySelector('[data-dv-ship]');
    var msg = drawer.querySelector('[data-dv-shipmsg]');
    var fill = drawer.querySelector('[data-dv-shipfill]');
    if(msg){ msg.innerHTML = unlocked ? '<b>Free shipping unlocked</b>' : ("You're <b>" + money(THRESHOLD - total) + "</b> from free shipping"); }
    if(fill){ fill.style.width = Math.min(100, Math.round(total / THRESHOLD * 100)) + '%'; }
    if(ship){ ship.classList.toggle('is-unlocked', unlocked); }
  }
  function render(cart){
    var count = document.querySelector('[data-dv-count]');
    if(count){ count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
    var box = drawer.querySelector('[data-dv-lines]');
    if(box){
      if(!cart.items.length){ box.innerHTML = '<p class="v2dv__empty">Your cart is empty.<br>The strips are waiting.</p>'; }
      else {
        box.innerHTML = cart.items.map(function(it, i){
          var thumb = it.image ? '<img src="' + it.image + '&width=120" alt="">' : (it.product_title || '').replace('Dissolvi ','').replace(' Strips (Demo)','').toUpperCase();
          return '<div class="v2dv__line">' +
            '<span class="v2dv__thumb">' + thumb + '</span>' +
            '<span class="v2dv__m"><p class="v2dv__n">' + (it.product_title || '').replace(' (Demo)','') + '</p>' +
            '<span class="v2dv__q"><button type="button" data-dvq="-1" data-line="' + (i+1) + '" aria-label="Decrease">-</button><span>' + it.quantity + '</span><button type="button" data-dvq="1" data-line="' + (i+1) + '" aria-label="Increase">+</button></span></span>' +
            '<span class="v2dv__p">' + money(it.final_line_price) + '</span></div>';
        }).join('');
        box.querySelectorAll('[data-dvq]').forEach(function(b){
          b.addEventListener('click', function(){
            var line = parseInt(b.getAttribute('data-line'), 10);
            var row = b.closest('.v2dv__line');
            var cur = parseInt(row.querySelector('.v2dv__q span').textContent, 10);
            var next = Math.max(0, cur + parseInt(b.getAttribute('data-dvq'), 10));
            fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ line: line, quantity: next }) })
              .then(function(r){ return r.json(); }).then(render);
          });
        });
      }
    }
    var sub = drawer.querySelector('[data-dv-subtotal]');
    if(sub) sub.textContent = money(cart.total_price);
    setShip(cart.total_price);
  }
  function refresh(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ render(c); return c; }); }
  function open(){ refresh().then(function(){ drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }); }
  function close(){ drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  document.querySelectorAll('[data-dv-open]').forEach(function(b){ b.addEventListener('click', open); });
  drawer.querySelector('[data-dv-close]').addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  document.addEventListener('dv:cart:added', open);
  window.dvCart = { open: open, refresh: refresh, close: close };
  refresh();
  document.querySelectorAll('[data-v2burger]').forEach(function(b){
    b.addEventListener('click', function(){
      var s = document.querySelector('[data-v2sheet]');
      var openSheet = s.classList.toggle('is-open');
      b.setAttribute('aria-expanded', openSheet ? 'true' : 'false');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.v2pdp').forEach(function(root){
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    if(!tiers.length) return;
    var qtyInput = root.querySelector('[data-qty-input]');
    var atcTotal = root.querySelector('[data-atc-total]');
    var stickyTotal = root.querySelector('[data-sticky-total]');
    var fill = root.querySelector('[data-ship-fill]');
    var msg = root.querySelector('[data-ship-msg]');
    var threshold = parseInt(root.getAttribute('data-ship-threshold'), 10) || 0;
    var remainTpl = root.getAttribute('data-ship-remaining') || '';
    var unlockedTxt = root.getAttribute('data-ship-unlocked') || '';
    function money(c){ return '$' + (c/100).toFixed(2); }
    var sub = root.querySelector('[data-sub]');
    var spInput = root.querySelector('[data-selling-plan]');
    var subMode = false, subUnit = 0, curTier = null;
    function render(){
      var t = curTier || tiers[0];
      var qty = parseInt(t.getAttribute('data-qty'), 10) || 1;
      var net = subMode ? (subUnit * qty) : (parseInt(t.getAttribute('data-net'), 10) || 0);
      if(qtyInput) qtyInput.value = qty;
      if(atcTotal) atcTotal.textContent = ' ' + money(net);
      if(stickyTotal) stickyTotal.textContent = ' ' + money(net);
      if(fill && threshold > 0){ fill.style.width = Math.min(100, Math.round(net / threshold * 100)) + '%'; }
      var shipBox = root.querySelector('.v2ship');
      var unlocked = net >= threshold;
      if(msg){ msg.innerHTML = unlocked ? ('<b>' + unlockedTxt + '</b> ✓') : remainTpl.replace('{amount}', '<b>' + money(threshold - net) + '</b>'); }
      if(shipBox){
        if(unlocked && !shipBox.classList.contains('is-unlocked')){ shipBox.classList.remove('is-unlocked'); void shipBox.offsetWidth; shipBox.classList.add('is-unlocked'); }
        else if(!unlocked){ shipBox.classList.remove('is-unlocked'); }
      }
    }
    function pick(t){
      tiers.forEach(function(x){ x.classList.remove('is-sel'); x.setAttribute('aria-pressed','false'); });
      t.classList.add('is-sel'); t.setAttribute('aria-pressed','true');
      curTier = t; render();
    }
    tiers.forEach(function(t){ t.addEventListener('click', function(){ pick(t); }); });
    if(sub){
      var subOpts = Array.prototype.slice.call(sub.querySelectorAll('[data-sub-opt]'));
      sub.querySelectorAll('[data-sub-radio]').forEach(function(r){
        r.addEventListener('change', function(){
          subMode = !!r.value;
          subUnit = parseInt(r.getAttribute('data-sub-unit'), 10) || 0;
          if(spInput){ spInput.value = r.value || ''; spInput.disabled = !r.value; }
          subOpts.forEach(function(o){ o.classList.toggle('is-sel', o.contains(r)); });
          render();
        });
      });
    }
    var initial = root.querySelector('[data-tier].is-sel') || tiers[0];
    pick(initial);
    var pform = root.querySelector('form[action*="/cart/add"]');
    if(pform){
      pform.addEventListener('submit', function(e){
        if(!window.dvCart) return;
        e.preventDefault();
        var btn = pform.querySelector('[name="add"]');
        var old = btn ? btn.innerHTML : '';
        if(btn){ btn.disabled = true; btn.innerHTML = 'Adding...'; }
        fetch('/cart/add.js', { method:'POST', body: new FormData(pform) })
          .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
          .then(function(){ document.dispatchEvent(new Event('dv:cart:added')); })
          .catch(function(){ pform.submit(); })
          .finally(function(){ if(btn){ btn.disabled = false; btn.innerHTML = old; } });
      });
    }
    var atcBtn = root.querySelector('.v2atc');
    var bar = root.querySelector('[data-stickybar]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    if(stickyAdd && atcBtn){ stickyAdd.addEventListener('click', function(){ atcBtn.click(); }); }
    if(bar && atcBtn && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ var show = !e.isIntersecting && e.boundingClientRect.top < 0; bar.classList.toggle('is-shown', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true'); }); }, { threshold: 0 }).observe(atcBtn);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-research"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-research-add]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var id = parseInt(btn.getAttribute('data-vid'), 10);
      if(!id) return;
      btn.disabled = true; var old = btn.textContent; btn.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){
          btn.disabled = false; btn.textContent = 'Added ✓';
          setTimeout(function(){ btn.textContent = old; }, 2400);
          document.dispatchEvent(new Event('dv:cart:added'));
        })
        .catch(function(){ btn.disabled = false; btn.textContent = old; });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-stack-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-stack-add]').forEach(function(btn){
    if(btn.getAttribute('data-bound')) return;
    btn.setAttribute('data-bound', '1');
    btn.addEventListener('click', function(){
      var ids = [btn.getAttribute('data-v1'), btn.getAttribute('data-v2'), btn.getAttribute('data-v3')].filter(Boolean);
      var items = ids.map(function(id){ return { id: parseInt(id, 10), quantity: 1 }; });
      btn.disabled = true; var old = btn.textContent; btn.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){
          btn.disabled = false; btn.textContent = 'Added ✓';
          setTimeout(function(){ btn.textContent = old; }, 2400);
          document.dispatchEvent(new Event('dv:cart:added'));
        })
        .catch(function(){ btn.disabled = false; btn.textContent = old; var e = document.querySelector('[data-stack-err]'); if(e) e.style.display = 'block'; });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-stack-day"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.v2skd').forEach(function(root){
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-day-card]'));
    var segs = Array.prototype.slice.call(root.querySelectorAll('[data-day-seg]'));
    if(!cards.length) return;
    function setOn(i){
      cards.forEach(function(c, j){ c.classList.toggle('is-on', j === i); });
      segs.forEach(function(s, j){ s.classList.toggle('is-on', i === -1 || j === i); });
    }
    cards.forEach(function(c, i){
      c.addEventListener('mouseenter', function(){ setOn(i); });
      c.addEventListener('focus', function(){ setOn(i); });
      c.addEventListener('click', function(){ setOn(i); });
    });
    root.addEventListener('mouseleave', function(){ setOn(-1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-stack-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-stack-add]').forEach(function(btn){
    if(btn.getAttribute('data-bound')) return;
    btn.setAttribute('data-bound', '1');
    btn.addEventListener('click', function(){
      var ids = [btn.getAttribute('data-v1'), btn.getAttribute('data-v2'), btn.getAttribute('data-v3')].filter(Boolean);
      var items = ids.map(function(id){ return { id: parseInt(id, 10), quantity: 1 }; });
      btn.disabled = true; var old = btn.textContent; btn.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){
          btn.disabled = false; btn.textContent = 'Added ✓';
          setTimeout(function(){ btn.textContent = old; }, 2400);
          document.dispatchEvent(new Event('dv:cart:added'));
        })
        .catch(function(){ btn.disabled = false; btn.textContent = old; var e = document.querySelector('[data-stack-err]'); if(e) e.style.display = 'block'; });
    });
  });
  document.querySelectorAll('.v2skh').forEach(function(root){
    var bar = root.querySelector('[data-stack-stick]');
    var cta = root.querySelector('.v2skh__cta [data-stack-add]');
    if(bar && cta && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-shown', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }); }, { threshold: 0 }).observe(cta);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.v2story').forEach(function(root){
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-story-step]'));
    if(!cards.length) return;
    var fill = root.querySelector('[data-story-fill]');
    var clock = root.querySelector('[data-story-clock]');
    var replay = root.querySelector('[data-story-replay]');
    var total = (parseFloat(root.getAttribute('data-secs')) || 3) * 1000;
    var per = total / cards.length;
    var HOLD = 1700;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var raf = null, holdT = null, t0 = 0, paused = false, inView = false;
    function setActive(i){
      cards.forEach(function(c, j){ c.classList.toggle('is-on', j === i); c.setAttribute('aria-current', j === i ? 'step' : 'false'); });
    }
    function setClock(ms){ if(clock) clock.textContent = (ms/1000).toFixed(1) + 's'; }
    function setFill(p){ if(fill) fill.style.width = (p*100).toFixed(1) + '%'; }
    function stop(){ if(raf){ cancelAnimationFrame(raf); raf = null; } if(holdT){ clearTimeout(holdT); holdT = null; } }
    function finish(){
      raf = null; root.classList.add('is-done'); setFill(1); setClock(total);
      holdT = setTimeout(function(){ holdT = null; if(!paused && inView) start(); }, HOLD);
    }
    function tick(now){
      var el = now - t0;
      if(el >= total){ finish(); return; }
      setClock(el); setFill(el/total);
      var i = Math.min(cards.length - 1, Math.floor(el/per));
      if(!cards[i].classList.contains('is-on')) setActive(i);
      raf = requestAnimationFrame(tick);
    }
    function start(){
      stop(); root.classList.remove('is-done');
      setActive(0); setFill(0); setClock(0);
      t0 = performance.now(); raf = requestAnimationFrame(tick);
    }
    function scrub(i){
      stop(); root.classList.remove('is-done'); paused = true;
      setActive(i); setFill((i + 1)/cards.length); setClock(per*(i + 1));
    }
    cards.forEach(function(c, i){
      c.addEventListener('mouseenter', function(){ scrub(i); });
      c.addEventListener('click', function(){ scrub(i); });
      c.addEventListener('focus', function(){ scrub(i); });
    });
    root.addEventListener('mouseleave', function(){ if(paused){ paused = false; if(!reduce && inView) start(); } });
    if(replay) replay.addEventListener('click', function(){ paused = false; if(reduce){ scrub(cards.length - 1); paused = false; root.classList.add('is-done'); } else { start(); } });
    if(reduce){ setActive(cards.length - 1); root.classList.add('is-done'); setFill(1); setClock(total); return; }
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(en){
        inView = en.isIntersecting;
        if(inView){ if(!paused && !raf && !holdT) start(); } else { stop(); }
      }); }, { threshold: 0.35 }).observe(root);
    } else { inView = true; start(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-switcher"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.v2sw').forEach(function(root){
    var tabs = root.querySelectorAll('[data-swtab]');
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        var i = t.getAttribute('data-swtab');
        tabs.forEach(function(x){ x.classList.remove('is-on'); x.setAttribute('aria-selected','false'); });
        t.classList.add('is-on'); t.setAttribute('aria-selected','true');
        root.querySelectorAll('[data-swpanel]').forEach(function(pn){ pn.hidden = pn.getAttribute('data-swpanel') !== i; });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
